module.exports = __webpack_public_path__ + "media/hyper/images/features-1-1ebc1f937962480f2136ff305f96a283.svg";